// Transform API message to our frontend type
export const transformApiMessage = (apiMsg) => ({
    id: apiMsg.id,
    content: apiMsg.content,
    sender: {
        id: apiMsg.senderId,
        name: apiMsg.senderName,
        role: apiMsg.senderType,
    },
    timestamp: apiMsg.createdAt,
    isRead: apiMsg.isRead,
    threadId: apiMsg.threadId,
    parentId: apiMsg.parentId || undefined,
    replies: apiMsg.replies?.map(transformApiMessage),
});
